import useCompanyStore from "@app-store/company";
import useLangStore from "@app-store/lang";
import useSystemStore from "@app-store/system";
import { QCollapse } from "@qamf/lighthouse";
import { BNav, BNavbar, BNavbarNav, BNavItem } from "bootstrap-vue-next";
import { computed, defineComponent, ref } from "vue";

export default defineComponent({
	name: "Menubar",
	components: {
		QCollapse,
		BNavbar,
		BNavbarNav,
		BNav,
		BNavItem
	},
	props: {},
	setup() {
		const expanded = ref(false);
		const navigationBar = computed(() => {
			return useSystemStore().navigationBar ?? [];
		});
		const hasMinimumData = computed(() => {
			return useLangStore().isoCode && useCompanyStore().Id && useSystemStore().info?.Id;
		});
		const ensureVoiceMenuUrl = (url: string) => {
			const regex = /^http[s]?:\/\//;
			if (!regex.test(url)) return `https://${url}`;
			return url;
		};
		const menuVoices = computed(() => {
			return navigationBar.value.map((menu) => ({
				label: menu.Label,
				url: menu.Url,
				isExternal: true
			}));
		});
		return {
			expanded,
			navigationBar,
			hasMinimumData,
			ensureVoiceMenuUrl,
			menuVoices
		};
	}
});
